import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import * as _redux from './setup';
import store, { persistor } from './setup/redux/Store';
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import { App } from './app/App';
import { MetronicI18nProvider } from './rbts/i18n/Metronici18n';
import './rbts/assets/sass/style.scss';
import './rbts/assets/sass/style.react.scss';
import './app/styles/theme.css';
import { initTheme } from './app/components/ThemeToggle';

initTheme();

const { PUBLIC_URL } = process.env;

_redux.setupAxios(axios, store);

Chart.register(...registerables);

ReactDOM.render(
  <MetronicI18nProvider>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<div>Cargando...</div>}>
        <App basename={PUBLIC_URL} />
      </PersistGate>
    </Provider>
  </MetronicI18nProvider>,
  document.getElementById('root')
);
